module.exports = __webpack_public_path__ + "static/media/mm3.4b2f0e31.jpg";